// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isValidAttributesArray = (attributes: any): attributes is AppProgram[] => {
  if (!Array.isArray(attributes)) {
    return false;
  }

  return attributes.every((item) => {
    return (
      typeof item === 'object' &&
      item !== null &&
      typeof item.code === 'string' &&
      typeof item.title === 'string' &&
      typeof item.visible === 'boolean' &&
      typeof item.active === 'boolean' &&
      typeof item.hasPermission === 'boolean' &&
      typeof item.status === 'string' &&
      (item.permission === undefined || typeof item.permission === 'string')
    );
  });
};

export default isValidAttributesArray;
